import ReactDOM from 'react-dom';
import preloaded from '../src/preloaded.js';
import MvpPageControls from '../src/mvps/MvpPageControls.js';

ReactDOM.render(
  <MvpPageControls mvp={preloaded.mvp} liked={preloaded.liked} />
, document.getElementById('app'));
